export enum Protocol {
    sctp = 'sctp',
    tcp = 'tcp',
    udp = 'udp'
}